import React from 'react'
import Logo from "../../../../Reutilizables/Logo"
import MenuContribuciones from './MenuContribuciones'
import TituloImpuestosMunicipales from '../../../../Reutilizables/TituloImpuestosMunicipales'
import Redes from '../../../../Reutilizables/Redes'

function Transferencia_sector_electrico() {
  return (
    <>
      <div className='container-logo-menu'>
        <Logo />
        <MenuContribuciones />
      </div>
      <TituloImpuestosMunicipales />
      <Redes />
    </>
  )
}

export default Transferencia_sector_electrico